import script from "./DebtDataList.vue?vue&type=script&setup=true&lang=js"
export * from "./DebtDataList.vue?vue&type=script&setup=true&lang=js"

import "./DebtDataList.vue?vue&type=style&index=0&id=6f51fe3d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f51fe3d"]])

export default __exports__